import { connect } from 'react-redux'
import { goBack, push } from 'connected-react-router'
import { withRouter } from 'react-router-dom'
import { compose, withHandlers } from 'recompose'
import { actions } from '../../../withTireSize'
import GoBack from './GoBack'

const withGoBackHandler = withHandlers({
  handleGoBack: ({ resetCustomTireSizeForm, history }) => () => {
    history.goBack()
    resetCustomTireSizeForm()
  }
})

export default compose(
  connect(null, { goBack, resetCustomTireSizeForm: actions.reset, push }),
  withRouter,
  withGoBackHandler
)(GoBack)
